import config from '../config';
import _ from 'lodash';

const xolaUrl = uri => {
    return config.xola.url + '/' + _.trimStart(uri, '/');
};

export default xolaUrl;
